import { demoFile, component, componentWithVariants, variant, story, CLICK, CHECK_TEXT } from 'system/demo';
import { AdaptiveLayoutTopicTeaserWithComment, NarrowTopicTeaserWithComment, TopicInfo, TopicTeaserFeature, WideTopicTeaserWithComment } from 'open-modules/cbcrc/feature/connect/topic-teaser';
import { t } from 'util/stdtypes';


demoFile('open-modules/cbcrc/feature/connect/topic-teaser');

const topic = {
    key: 1,
    from: 'a',
    text: 'Is Godzilla good?'
};

const commentPreview = {
    key: 1,
    from: 'a',
    text: 'I love Godzilla. He is so cute.',
    time: Date.now(),
    upvoteCount: 5
};

const collections = {
    derived_topicPreview: [{ key: 1, commentCount: 1234, commentPreview, name: 'Is Godzilla good?' }]
};

const emptyStateCollection = {
    derived_topicPreview: [{ key: 1 }]
};

// Legacy demo used receivesConfigDefaults to show a graphic; not required in this version
const configWithGraphic = {};

componentWithVariants('AdaptiveLayoutTopicTeaserWithComment', AdaptiveLayoutTopicTeaserWithComment, {}, [
    variant('Default', { args: { topic, commentPreview, commentCount: 12 }, state: { collections } }),
    variant('Empty state with graphic', { args: { topic }, state: { collections: emptyStateCollection }, config: configWithGraphic })
]);

component('WideTopicTeaserWithComment', WideTopicTeaserWithComment, {
    args: {
        header: 'Topic of the moment',
        icon: 'star',
        emptyState: 'Be the first to share your thoughts',
        countFormat: { count: 5, singular: t('participant'), plural: t('participants') },
        title: topic.text,
        instanceKey: 'topic',
        commentPreview,
        commentCount: 5,
        callToAction: 'Share your thoughts'
    },
    state: { collections }
}, [
    story('Display', [CHECK_TEXT('Share your thoughts')])
]);

component('NarrowTopicTeaserWithComment', NarrowTopicTeaserWithComment, {
    args: {
        header: 'Topic of the moment',
        icon: 'star',
        emptyState: 'Be the first to share your thoughts',
        countFormat: { count: 5, singular: t('participant'), plural: t('participants') },
        title: topic.text,
        instanceKey: 'topic',
        commentPreview,
        commentCount: 5,
        callToAction: 'Share your thoughts'
    },
    state: { collections }
});

component('TopicInfo', TopicInfo, {
    args: {
        header: 'Topic of the moment',
        icon: 'star',
        title: topic.text,
        emptyState: t('Be the first to share your thoughts'),
        countFormat: { count: 5, singular: t('participant'), plural: t('participants') },
        structureKey: 'topic',
        instanceKey: 'topic',
        commentCount: 42
    }
});
